import { render, staticRenderFns } from "./habilitarLicenca.vue?vue&type=template&id=3d836008&"
import script from "./habilitarLicenca.vue?vue&type=script&lang=js&"
export * from "./habilitarLicenca.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports